import { inject, Pipe, PipeTransform } from '@angular/core';
import { GeneralUtilsService } from '../services/general-utils.service';

@Pipe({
  name: 'cacheBusterImage',
  standalone: false,
})
export class CacheBusterImagePipe implements PipeTransform {
  private readonly generalUtilsService = inject(GeneralUtilsService);

  transform(value: string, version: string = ''): string {
    if (!value || this.generalUtilsService.isBase64Image(value)) {
      return value;
    }

    version = version || new Date().getTime().toString();

    if (value.indexOf('?') > -1) {
      return value + '&v=' + version;
    } else {
      return value + '?v=' + version;
    }
  }
}
